import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const styles = {
  page: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    fontFamily: 'Inter, Roboto, Open Sans, sans-serif',
  },
  breadcrumb: {
    fontSize: '0.85rem',
    color: '#666',
    marginBottom: '0.5rem',
  },
  breadcrumbLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  statsRow: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1.5rem',
    flexWrap: 'wrap',
  },
  statCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '1.25rem 1.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    minWidth: '180px',
    borderLeft: '4px solid #1976d2',
  },
  statLabel: {
    fontSize: '0.75rem',
    color: '#666',
    textTransform: 'uppercase',
    fontWeight: '600',
    marginBottom: '0.25rem',
    letterSpacing: '0.05em',
  },
  statValue: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: '#333',
  },
  searchCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '1rem 1.25rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '1.5rem',
  },
  searchInput: {
    width: '100%',
    padding: '0.65rem 1rem',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  },
  tableCard: {
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    padding: '0.75rem 1rem',
    textAlign: 'left',
    fontSize: '0.75rem',
    fontWeight: '600',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '2px solid #e5e7eb',
    backgroundColor: '#fafafa',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '0.75rem 1rem',
    fontSize: '0.9rem',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
  },
  trEven: {
    backgroundColor: '#fafafa',
  },
  trOdd: {
    backgroundColor: '#fff',
  },
  trHover: {
    cursor: 'pointer',
  },
  badgeSim: {
    display: 'inline-block',
    padding: '0.2rem 0.6rem',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: '600',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  badgeNao: {
    display: 'inline-block',
    padding: '0.2rem 0.6rem',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: '600',
    backgroundColor: '#f5f5f5',
    color: '#757575',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '1rem',
  },
  modal: {
    background: '#fff',
    borderRadius: '12px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    position: 'relative',
  },
  modalHeader: {
    padding: '1.5rem',
    borderBottom: '1px solid #e5e7eb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: '700',
    color: '#333',
    margin: 0,
  },
  modalSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: '0.25rem 0 0 0',
  },
  modalCloseBtn: {
    background: 'none',
    border: 'none',
    fontSize: '1.25rem',
    color: '#999',
    cursor: 'pointer',
    padding: '0.25rem',
    lineHeight: 1,
  },
  modalBody: {
    padding: '1.5rem',
  },
  detailGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem',
  },
  detailItem: {
    marginBottom: '0.25rem',
  },
  detailLabel: {
    fontSize: '0.7rem',
    fontWeight: '600',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '0.15rem',
  },
  detailValue: {
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#333',
  },
  detailFull: {
    gridColumn: '1 / -1',
    marginBottom: '0.25rem',
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '300px',
    fontSize: '1rem',
    color: '#666',
  },
  emptyState: {
    textAlign: 'center',
    padding: '3rem 1rem',
    color: '#999',
    fontSize: '0.95rem',
  },
};

function Responsaveis() {
  const [responsaveis, setResponsaveis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedResponsavel, setSelectedResponsavel] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    fetchResponsaveis();
  }, []);

  const fetchResponsaveis = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/responsaveis`);
      const data = response.data.data || response.data || [];
      setResponsaveis(data);
    } catch (err) {
      console.error('Erro ao buscar responsaveis:', err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = responsaveis.filter((r) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      (r.NOME && r.NOME.toLowerCase().includes(term)) ||
      (r.CRF && String(r.CRF).toLowerCase().includes(term))
    );
  });

  const handleRowClick = (responsavel) => {
    setSelectedResponsavel(responsavel);
  };

  const handleCloseModal = () => {
    setSelectedResponsavel(null);
  };

  const renderBadge = (value) => {
    if (value === 'S') {
      return <span style={styles.badgeSim}>Sim</span>;
    }
    return <span style={styles.badgeNao}>Nao</span>;
  };

  if (loading) {
    return (
      <div className="data-page" style={styles.page}>
        <div style={styles.loading}>Carregando responsaveis...</div>
      </div>
    );
  }

  return (
    <div className="data-page" style={styles.page}>
      {/* Breadcrumb */}
      <div style={styles.breadcrumb}>
        <span style={styles.breadcrumbLink}>Inicio</span>
        <span> / </span>
        <span>Responsaveis Tecnicos</span>
      </div>

      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>👨‍🔬</span>
          <div>
            <h1 style={styles.pageTitle}>Responsaveis Tecnicos</h1>
            <p style={styles.pageSubtitle}>
              Gerenciamento de responsaveis tecnicos do laboratorio
            </p>
          </div>
        </div>
      </div>

      {/* Contadores */}
      <div className="responsive-flex" style={styles.statsRow}>
        <div style={styles.statCard}>
          <div style={styles.statLabel}>Total de Responsaveis</div>
          <div style={styles.statValue}>{filtered.length}</div>
        </div>
      </div>

      {/* Campo de Busca */}
      <div style={styles.searchCard}>
        <input
          type="text"
          placeholder="Buscar por nome ou CRF..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.searchInput}
        />
      </div>

      {/* Tabela */}
      <div style={styles.tableCard}>
        <div style={styles.tableResponsive}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>CRF</th>
                <th style={styles.th}>Nome</th>
                <th style={styles.th}>Conselho</th>
                <th style={styles.th}>UF</th>
                <th style={styles.th}>Telefone</th>
                <th style={styles.th}>Email</th>
                <th style={{ ...styles.th, textAlign: 'center' }}>Conf. Final</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan="7" style={styles.emptyState}>
                    Nenhum responsavel encontrado.
                  </td>
                </tr>
              ) : (
                filtered.map((resp, index) => (
                  <tr
                    key={resp.CRF || index}
                    onClick={() => handleRowClick(resp)}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{
                      ...(index % 2 === 0 ? styles.trEven : styles.trOdd),
                      ...(hoveredRow === index ? { backgroundColor: '#e3f2fd' } : {}),
                      ...styles.trHover,
                    }}
                  >
                    <td style={styles.td}>
                      <strong>{resp.CRF || '-'}</strong>
                    </td>
                    <td style={styles.td}>{resp.NOME || '-'}</td>
                    <td style={styles.td}>{resp.CONSELHO_PROF || '-'}</td>
                    <td style={styles.td}>{resp.UF_CONSELHO || '-'}</td>
                    <td style={styles.td}>{resp.TELEFONE || resp.CELULAR || '-'}</td>
                    <td style={styles.td}>{resp.EMAIL || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      {renderBadge(resp.CONFERENCIA_FINAL)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal de Detalhes */}
      {selectedResponsavel && (
        <div style={styles.overlay} onClick={handleCloseModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            {/* Header do Modal */}
            <div style={styles.modalHeader}>
              <div>
                <h2 style={styles.modalTitle}>{selectedResponsavel.NOME || 'Responsavel'}</h2>
                <p style={styles.modalSubtitle}>CRF: {selectedResponsavel.CRF || '-'}</p>
              </div>
              <button style={styles.modalCloseBtn} onClick={handleCloseModal}>
                X
              </button>
            </div>

            {/* Body do Modal */}
            <div style={styles.modalBody}>
              <div className="responsive-grid" style={styles.detailGrid}>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>CRF</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CRF || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>CPF</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CPF || '-'}</div>
                </div>

                <div style={styles.detailFull}>
                  <div style={styles.detailLabel}>Nome</div>
                  <div style={styles.detailValue}>{selectedResponsavel.NOME || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Identidade</div>
                  <div style={styles.detailValue}>{selectedResponsavel.IDENTIDADE || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>CNS</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CNS || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Conselho Profissional</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CONSELHO_PROF || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>UF Conselho</div>
                  <div style={styles.detailValue}>{selectedResponsavel.UF_CONSELHO || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Telefone</div>
                  <div style={styles.detailValue}>{selectedResponsavel.TELEFONE || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Celular</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CELULAR || '-'}</div>
                </div>

                <div style={styles.detailFull}>
                  <div style={styles.detailLabel}>Email</div>
                  <div style={styles.detailValue}>{selectedResponsavel.EMAIL || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Classificacao</div>
                  <div style={styles.detailValue}>{selectedResponsavel.CLASSIFICACAO || '-'}</div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Conferencia Final</div>
                  <div style={styles.detailValue}>
                    {renderBadge(selectedResponsavel.CONFERENCIA_FINAL)}
                  </div>
                </div>

                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>Restrito</div>
                  <div style={styles.detailValue}>
                    {renderBadge(selectedResponsavel.RESTRITO)}
                  </div>
                </div>
              </div>

              {/* Botao Fechar */}
              <div style={{ marginTop: '1.5rem', textAlign: 'right' }}>
                <button
                  onClick={handleCloseModal}
                  style={{
                    padding: '0.6rem 1.5rem',
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Responsaveis;
